import { svg } from 'lit';

const symbol = svg`<svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.25 5.25v-1.5-1.5h3M12.75 2.25h3v3M15.75 12.75v3h-3M5.252 15.75H2.25l.002-1.5v-1.5" stroke="currentColor" stroke-width=".5" stroke-linecap="square" stroke-linejoin="round"/></svg>`;

export { symbol as default };
